/**
 * @generated SignedSource<<2bac81368991f47ab31dd657ba3143df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PrivateNoteSidePanelFragment$data = {
  readonly id: string;
  readonly linkedNote: {
    readonly createdAt: string | null;
    readonly eventStart: string | null;
    readonly url: string | null;
  } | null;
  readonly note: {
    readonly attachments: ReadonlyArray<{
      readonly dimensions: {
        readonly height: number;
        readonly width: number;
      } | null;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AttachmentPreviewAttachment">;
    }>;
    readonly collapsedBlockKeys: ReadonlyArray<string>;
    readonly id: string;
    readonly rawDraftJson: any;
    readonly updatedAt: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"AttachmentsRelay_note">;
  };
  readonly title: string | null;
  readonly updatedAt: string | null;
  readonly " $fragmentType": "PrivateNoteSidePanelFragment";
};
export type PrivateNoteSidePanelFragment$key = {
  readonly " $data"?: PrivateNoteSidePanelFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PrivateNoteSidePanelFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PrivateNoteSidePanelFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "collapsedBlockKeys",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rawDraftJson",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AttachmentsRelay_note"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Attachment",
          "kind": "LinkedField",
          "name": "attachments",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageDimensions",
              "kind": "LinkedField",
              "name": "dimensions",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "AttachmentPreviewAttachment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "filename",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": "directUrl",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "size",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ImageDimensions",
                  "kind": "LinkedField",
                  "name": "dimensions",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "filetype",
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "linkedNote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PrivateNote",
  "abstractKey": null
};
})();

(node as any).hash = "d236e29c858b5914dc1440a102332101";

export default node;
